import React, { useRef } from 'react';
import { compose, setPropTypes, pure, withState } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Button, Popover } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { connect } from 'react-redux';
import MoreContentButton from '../atoms/MoreContentButton';
import enabledStripeBilling from '../../constants/StripeBilling';
import Flags from '../../constants/Flags';
import usageTypes from '../../constants/UsageType';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  overWrap: {
    whiteSpace: 'pre-line',
    width: '500px'
  },
  verticalAlignTop: {
    verticalAlign: 'top'
  },
  buttonDelete: {
    paddingTop: '0px'
  },
  cellOverflow: {
    minWidth: 200,
    // overflow: 'hidden',
    // textOverflow: 'ellipsis'
    whiteSpace: 'pre-line'
  },
  btnMoreUpdateAmount: {
    minWidth: 'unset',
    color: '#2196F3'
  },
  btnUpdateAmountHistory: {
    fontSize: 14,
    fontWeight: 400,
    color: '#2196F3',
    textDecoration: 'underline',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  btnUpdateAmount: {
    fontSize: 14,
    fontWeight: 400,
    color: '#F50057',
    textDecoration: 'underline',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  btnUpdateAmountBox: {
    padding: 10
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  gochis: PropTypes.arrayOf(
    PropTypes.shape({
      gochiBillNo: PropTypes.string,
      couponId: PropTypes.number,
      groupName: PropTypes.string,
      menuName: PropTypes.string,
      shopName: PropTypes.string,
      price: PropTypes.number,
      type: PropTypes.string,
      registerDate: PropTypes.string,
      taxType: PropTypes.string,
      registerName: PropTypes.string,
      userName: PropTypes.string,
      useDate: PropTypes.string,
      expiration: PropTypes.string,
      shopMessage: PropTypes.string,
      gochiMessage: PropTypes.string,
      situation: PropTypes.string,
      thanksMessage: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes),
  withState('state', 'setState', {
    openedPopoverId: null,
    anchorEl: null
  }),
  connect(
    state => ({
      account: state.accounts.account
    }),
    () => ({})
  )
);

const GochiTableBody = enhance(
  ({
    classes,
    gochis,
    // emptyRows, // rowsPerPage, // page,
    messageViewAction,
    order,
    orderBy,
    account,
    isFukuoka,
    isNaha,
    state,
    setState,
    openUpdateAmountModal,
    openUpdateAmountHistory
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const popoverAnchor = useRef(null);

    // searchEs
    let sortedResult = [];
    if (orderBy === 'streetAddress') {
      sortedResult = _.orderBy(
        gochis,
        ['prefectures', 'city', 'address', 'building'],
        [order, order, order, order]
      );
    } else if (orderBy === 'menuName') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.menuName;
        },
        order
      );
    } else if (orderBy === 'reducedTaxTypeStr') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.reducedTaxTypeStr;
        },
        order
      );
    } else if (orderBy === 'gochiStatus') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.sourceTable !== 'SHASHOKU'
            ? gochi.coupons[0].gochiStatus
            : gochi.shashokuStatusUse;
        },
        order
      );
    } else if (orderBy === 'useDate') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.sourceTable !== 'SHASHOKU'
            ? gochi.coupons[0].useDate
            : gochi.useDate;
        },
        order
      );
    } else if (orderBy === 'gochiUserName') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.coupons && gochi.coupons[0].gochiUserName;
        },
        order
      );
    } else if (orderBy === 'couponShopMessage') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.coupons && gochi.coupons[0].couponShopMessage;
        },
        order
      );
    } else if (orderBy === 'accountId') {
      sortedResult = _.orderBy(
        gochis,
        gochi => {
          return gochi.sourceTable !== 'SHASHOKU' &&
            gochi.sourceTable !== 'GOCHI_KID'
            ? gochi.coupons[0].accountId
            : gochi.accountId;
        },
        order
      );
    } else {
      sortedResult = _.orderBy(gochis, orderBy, order);
    }

    return (
      <TableBody>
        {sortedResult
          // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((gochi, index) => {
            const moreMessageLength = Number(
              process.env.REACT_APP_MORE_MESSAGE_LENGTH
            );
            const LOCAL_WALLET = '地域通貨チケット';
            const GOCHI_KID = 'GOCHI_KID';
            let key = `${gochi.gochiBillId}-${gochi.groupId}${
              gochi.gochiTypeStr === LOCAL_WALLET
                ? `${
                    gochi.coupons && gochi.coupons.length > 0
                      ? `-${gochi.coupons[0].couponId}`
                      : `-${index}`
                  }`
                : ``
            }`;
            if (gochi.sourceTable === 'SHASHOKU') {
              key = `SHASHOKU${index}`;
            } else if (gochi.sourceTable === GOCHI_KID) {
              key = `${GOCHI_KID}${index}`;
            }

            const handlePopoverOpen = (event, popoverId) => {
              setState({
                openedPopoverId: popoverId,
                anchorEl: event.target
              });
            };

            const handlePopoverClose = () => {
              setState({
                openedPopoverId: null,
                anchorEl: null
              });
            };

            const { anchorEl, openedPopoverId } = state;

            return (
              <TableRow key={key} className={classes.verticalAlignTop}>
                <TableCell>{gochi.gochiBillNo}</TableCell>
                <TableCell>{gochi.shopId}</TableCell>
                {!isFukuoka && (
                  <TableCell className={classes.cellOverflow}>
                    {gochi.groupName}
                  </TableCell>
                )}
                <TableCell className={classes.cellOverflow}>
                  {gochi.shopName}
                </TableCell>
                <TableCell>
                  {gochi.prefectures}
                  {` `}
                  {gochi.city}
                  {` `}
                  {gochi.address}
                  {` `}
                  {gochi.building}
                </TableCell>
                {!isFukuoka && (
                  <TableCell>
                    {gochi.companyName || gochi.connectSystemName}
                  </TableCell>
                )}
                <TableCell>{gochi.createdAt}</TableCell>
                {!isFukuoka && <TableCell>{gochi.registerName}</TableCell>}
                <TableCell>
                  {gochi.shopMessage && (
                    <div className={classes.overWrap}>
                      {/* メッセージの文字数が設定値を超えていれば、表示文字数制限 + moreアイコン */}
                      {gochi.shopMessage.length > moreMessageLength &&
                        gochi.shopMessage.substring(0, moreMessageLength)}
                      {gochi.shopMessage.length > moreMessageLength && (
                        <MoreContentButton
                          content={gochi.shopMessage}
                          onClickAction={messageViewAction}
                        />
                      )}
                      {/* メッセージの文字数が設定値以下であれば、そのまま表示 */}
                      {gochi.shopMessage.length <= moreMessageLength &&
                        gochi.shopMessage}
                    </div>
                  )}
                </TableCell>
                {!isFukuoka && (
                  <>
                    <TableCell>
                      {gochi.sourceTable !== 'SHASHOKU' &&
                        gochi.sourceTable !== GOCHI_KID &&
                        gochi.giftCardCategoryName}
                    </TableCell>
                    <TableCell>
                      {gochi.sourceTable !== 'SHASHOKU' &&
                        gochi.sourceTable !== GOCHI_KID &&
                        gochi.giftCardName}
                    </TableCell>
                    <TableCell>
                      {gochi.sourceTable !== 'SHASHOKU' &&
                        gochi.sourceTable !== GOCHI_KID &&
                        gochi.gochiMessage && (
                          <div className={classes.overWrap}>
                            {/* メッセージの文字数が設定値を超えていれば、表示文字数制限 + moreアイコン */}
                            {gochi.gochiMessage.length > moreMessageLength &&
                              gochi.gochiMessage.substring(
                                0,
                                moreMessageLength
                              )}
                            {gochi.gochiMessage.length > moreMessageLength && (
                              <MoreContentButton
                                content={gochi.gochiMessage}
                                onClickAction={messageViewAction}
                              />
                            )}
                            {/* メッセージの文字数が設定値以下であれば、そのまま表示 */}
                            {gochi.gochiMessage.length <= moreMessageLength &&
                              gochi.gochiMessage}
                          </div>
                        )}
                    </TableCell>
                  </>
                )}
                {isFukuoka && <TableCell>{gochi.menuId}</TableCell>}
                <TableCell>{gochi.menuName}</TableCell>
                {!isFukuoka && (
                  <>
                    <TableCell>{gochi.gochiTypeStr}</TableCell>
                    <TableCell>{gochi.gochiUserTypeStr}</TableCell>
                  </>
                )}
                {enabledStripeBilling === true && (
                  <TableCell>
                    {!!gochi.subscriptionId &&
                      `${gochi.subscriptionIntervalCount}${
                        gochi.subscriptionInterval === 'WEEK' ? '週間' : 'ヶ月'
                      }1回`}
                  </TableCell>
                )}
                <TableCell>{gochi.totalCoupon}</TableCell>
                {!isFukuoka && <TableCell>{gochi.reducedTaxTypeStr}</TableCell>}
                <TableCell>
                  {gochi.usageType === USAGE_TYPE_MENU || isFukuoka
                    ? gochi.amount.toLocaleString()
                    : '-'}
                </TableCell>
                <TableCell>
                  {(
                    gochi.amount +
                    gochi.taxAmount -
                    gochi.discountAmount
                  ).toLocaleString()}
                </TableCell>
                {!isFukuoka && (
                  <>
                    <TableCell>
                      {gochi.discountAmount.toLocaleString()}
                    </TableCell>
                    <TableCell>{gochi.depositPlanStr}</TableCell>
                    {/* <TableCell>{gochi.amount + gochi.taxAmount}</TableCell> */}
                    <TableCell>
                      {gochi.amountTransferToShopWhenBuy.toLocaleString()}
                    </TableCell>
                  </>
                )}

                {gochi.sourceTable !== 'SHASHOKU' &&
                gochi.sourceTable !== GOCHI_KID ? (
                  <>
                    <TableCell>
                      {gochi.coupons &&
                        gochi.coupons.map(coupon => {
                          return (
                            <div key={coupon.couponId}>
                              {coupon.gochiStatus}
                            </div>
                          );
                        })}
                    </TableCell>
                    <TableCell>
                      {gochi.coupons &&
                        gochi.coupons.map(coupon => {
                          return (
                            <div key={coupon.couponId}>
                              {coupon.useDate ||
                                (gochi.menuLimitTotal === 1 ? '-' : '')}
                            </div>
                          );
                        })}
                    </TableCell>
                  </>
                ) : (
                  <>
                    <TableCell>
                      {gochi.sourceTable === GOCHI_KID
                        ? gochi.gochiKidStatusUse
                        : gochi.shashokuStatusUse}
                    </TableCell>
                    <TableCell>{gochi.useDate}</TableCell>
                  </>
                )}
                {isFukuoka && (
                  <TableCell>
                    {gochi.sourceTable !== 'SHASHOKU' &&
                    gochi.sourceTable !== GOCHI_KID
                      ? gochi.coupons &&
                        gochi.coupons.map(coupon => {
                          return (
                            <div key={coupon.couponId}>
                              {coupon.accountId && `${coupon.accountId} `}
                            </div>
                          );
                        })
                      : gochi.accountId}
                  </TableCell>
                )}
                {gochi.sourceTable !== 'SHASHOKU' &&
                gochi.sourceTable !== GOCHI_KID ? (
                  <TableCell>
                    {gochi.coupons &&
                      gochi.coupons.map(coupon => {
                        return (
                          <div
                            key={coupon.couponId}
                            className={classes.overWrap}
                          >
                            {coupon.gochiUserName}
                            {coupon.thanksMessage && `（`}
                            {/* メッセージの文字数が設定値を超えていれば、表示文字数制限 + moreアイコン */}
                            {coupon.thanksMessage &&
                              coupon.thanksMessage.length > moreMessageLength &&
                              coupon.thanksMessage.substring(
                                0,
                                moreMessageLength
                              )}
                            {coupon.thanksMessage &&
                              coupon.thanksMessage.length >
                                moreMessageLength && (
                                <MoreContentButton
                                  content={coupon.thanksMessage}
                                  onClickAction={messageViewAction}
                                />
                              )}
                            {/* メッセージの文字数が設定値以下であれば、そのまま表示 */}
                            {coupon.thanksMessage &&
                              coupon.thanksMessage.length <=
                                moreMessageLength &&
                              coupon.thanksMessage}
                            {coupon.thanksMessage &&
                              coupon.thanksMessage.length <=
                                moreMessageLength &&
                              `）`}
                          </div>
                        );
                      })}
                  </TableCell>
                ) : (
                  <TableCell>
                    {account.fukuokaFlag || isNaha
                      ? gochi.shashokuUserName
                      : ''}
                    {gochi.gochiMessage && `（${gochi.gochiMessage}）`}
                  </TableCell>
                )}
                {!isFukuoka && (
                  <TableCell>
                    {gochi.sourceTable !== 'SHASHOKU' &&
                    gochi.sourceTable !== GOCHI_KID
                      ? gochi.coupons &&
                        gochi.coupons.map(coupon => {
                          return (
                            <div key={coupon.couponId}>
                              {coupon.couponShopMessage &&
                                `${coupon.couponShopMessage} `}
                            </div>
                          );
                        })
                      : ''}
                  </TableCell>
                )}
                {!isFukuoka && (
                  <>
                    <TableCell>
                      {gochi.sourceTable === GOCHI_KID &&
                        gochi.gochiKidGroupName}
                    </TableCell>
                    <TableCell>
                      {gochi.sourceTable === GOCHI_KID &&
                        (gochi.userKids &&
                          gochi.userKids.map(user => {
                            return (
                              <div key={user.userKidId}>{user.userKidId}</div>
                            );
                          }))}
                    </TableCell>
                    <TableCell>
                      {gochi.sourceTable === GOCHI_KID &&
                        (gochi.userKids &&
                          gochi.userKids.map(user => {
                            return (
                              <div key={user.userKidId}>{user.displayName}</div>
                            );
                          }))}
                    </TableCell>
                  </>
                )}
                <TableCell>
                  {gochi.sourceTable !== 'SHASHOKU' &&
                  gochi.sourceTable !== GOCHI_KID
                    ? gochi.coupons &&
                      gochi.coupons.map(coupon => {
                        return (
                          <div key={coupon.couponId}>
                            {(coupon.useForShopId &&
                              `${coupon.useForShopId} `) ||
                              (gochi.menuLimitTotal === 1 ? '-' : '')}
                          </div>
                        );
                      })
                    : gochi.shopId}
                </TableCell>
                <TableCell>
                  {gochi.sourceTable !== 'SHASHOKU' &&
                  gochi.sourceTable !== GOCHI_KID
                    ? gochi.coupons &&
                      gochi.coupons.map(coupon => {
                        return (
                          <div key={coupon.couponId}>
                            {(coupon.useForShopName &&
                              `${coupon.useForShopName} `) ||
                              '-'}
                          </div>
                        );
                      })
                    : gochi.shopName}
                </TableCell>
                {!isFukuoka && (
                  <>
                    <TableCell>
                      {// eslint-disable-next-line no-nested-ternary
                      gochi.sourceTable !== 'SHASHOKU' &&
                      gochi.sourceTable !== GOCHI_KID
                        ? gochi.coupons &&
                          gochi.coupons.map(coupon => {
                            if (gochi.menuLimitTotal === 0) {
                              return coupon.useDate !== null ? (
                                <div key={`couponCount${coupon.couponId}`}>
                                  1
                                </div>
                              ) : (
                                <div key={`couponCount${coupon.couponId}`}>
                                  0
                                </div>
                              );
                            }
                            return (
                              <div key={`couponCount${coupon.couponId}`}>-</div>
                            );
                          })
                        : gochi.sourceTable === GOCHI_KID
                        ? gochi.userKids &&
                          gochi.userKids.map(userKid => {
                            return <div key={userKid.userKidId}>1</div>;
                          })
                        : 1}
                    </TableCell>
                    <TableCell>
                      {// eslint-disable-next-line no-nested-ternary
                      gochi.sourceTable !== 'SHASHOKU' &&
                      gochi.sourceTable !== GOCHI_KID
                        ? gochi.coupons &&
                          gochi.coupons.map(coupon => {
                            return coupon.useDate !== null ? (
                              <div key={`couponCount${coupon.couponId}`}>
                                {gochi.gochiTypeStr === LOCAL_WALLET
                                  ? '-'
                                  : coupon.amount !== null &&
                                    coupon.amount.toLocaleString()}
                              </div>
                            ) : (
                              <div key={`couponCount${coupon.couponId}`}>
                                {gochi.menuLimitTotal === 1 ? '-' : 0}
                              </div>
                            );
                          })
                        : gochi.sourceTable === GOCHI_KID
                        ? gochi.userKids &&
                          gochi.userKids.map(userKid => {
                            return (
                              <div key={userKid.userKidId}>
                                {userKid.usedExternalAmount.toLocaleString()}
                              </div>
                            );
                          })
                        : gochi.usedExternalAmount.toLocaleString()}
                    </TableCell>
                    <TableCell>
                      {// eslint-disable-next-line no-nested-ternary
                      gochi.sourceTable !== 'SHASHOKU' &&
                      gochi.sourceTable !== GOCHI_KID
                        ? gochi.coupons &&
                          gochi.coupons.map(coupon => {
                            return coupon.useDate !== null ? (
                              <div key={`couponCount${coupon.couponId}`}>
                                {gochi.gochiTypeStr === LOCAL_WALLET
                                  ? '-'
                                  : (
                                      coupon.amount + coupon.taxAmount
                                    ).toLocaleString()}
                              </div>
                            ) : (
                              <div key={`couponCount${coupon.couponId}`}>
                                {gochi.menuLimitTotal === 1 ? '-' : 0}
                              </div>
                            );
                          })
                        : gochi.sourceTable === GOCHI_KID
                        ? gochi.userKids &&
                          gochi.userKids.map(userKid => {
                            return (
                              <div key={userKid.userKidId}>
                                {userKid.usedInternalAmountSum &&
                                  userKid.usedInternalAmountSum.toLocaleString()}
                              </div>
                            );
                          })
                        : gochi.usedInternalAmountSum &&
                          gochi.usedInternalAmountSum.toLocaleString()}
                    </TableCell>
                    <TableCell>
                      {(() => {
                        if (gochi.menuLimitTotal === 0) {
                          return gochi.couponUsedCount
                            ? gochi.couponUsedCount.toLocaleString()
                            : 0;
                        }
                        return '-';
                      })()}
                    </TableCell>
                    <TableCell>
                      {(() => {
                        if (gochi.gochiTypeStr !== LOCAL_WALLET) {
                          return gochi.usedInternalAmountSum
                            ? gochi.usedInternalAmountSum.toLocaleString()
                            : 0;
                        }
                        return '-';
                      })()}
                    </TableCell>
                    {Flags.showAddedAmountMenuLimitTotalAtSearchGochi && (
                      <TableCell>{gochi.addedAmount}</TableCell>
                    )}
                    <TableCell>
                      {gochi.gochiTypeStr !== LOCAL_WALLET
                        ? gochi.couponNotUseAmount
                        : '-'}
                    </TableCell>
                  </>
                )}
                <TableCell>
                  {gochi.sourceTable !== 'SHASHOKU' &&
                  gochi.sourceTable !== GOCHI_KID ? (
                    <>
                      {gochi.coupons &&
                        gochi.coupons.map(coupon => {
                          return (
                            <div key={coupon.couponId}>
                              {coupon.amountTransferToShopWhenUse !== null ? (
                                <span>
                                  {coupon.amountTransferToShopWhenUse
                                    ? coupon.amountTransferToShopWhenUse.toLocaleString()
                                    : 0}
                                </span>
                              ) : null}
                              {isFukuoka &&
                                gochi.sourceTable === 'GOCHI' &&
                                gochi.gochiTypeStr === LOCAL_WALLET &&
                                ((coupon.editAmountFlag === 1 &&
                                  coupon.amountTransferToShopWhenUse) ||
                                  coupon.showHistoryFlag === 1) && (
                                  <>
                                    <Button
                                      key={`GOCHI-${gochi.gochiBillId}-${
                                        coupon.couponId
                                      }`}
                                      ref={popoverAnchor}
                                      onClick={e =>
                                        handlePopoverOpen(
                                          e,
                                          `GOCHI-${gochi.gochiBillId}-${
                                            coupon.couponId
                                          }`
                                        )
                                      }
                                      className={classes.btnMoreUpdateAmount}
                                    >
                                      <MoreHorizIcon />
                                    </Button>
                                    <Popover
                                      elevation={1}
                                      id="mouse-over-popover"
                                      open={
                                        openedPopoverId ===
                                        `GOCHI-${gochi.gochiBillId}-${
                                          coupon.couponId
                                        }`
                                      }
                                      anchorEl={anchorEl}
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center'
                                      }}
                                      onClose={handlePopoverClose}
                                      disableRestoreFocus
                                    >
                                      <div
                                        className={classes.btnUpdateAmountBox}
                                      >
                                        {coupon.showHistoryFlag ? (
                                          <div>
                                            <Button
                                              className={
                                                classes.btnUpdateAmountHistory
                                              }
                                              onClick={() =>
                                                openUpdateAmountHistory(
                                                  coupon.couponId,
                                                  null
                                                )
                                              }
                                            >
                                              金額修正履歴
                                            </Button>
                                          </div>
                                        ) : null}
                                        {coupon.editAmountFlag &&
                                        coupon.amountTransferToShopWhenUse ? (
                                          <div>
                                            <Button
                                              className={
                                                classes.btnUpdateAmount
                                              }
                                              onClick={() => {
                                                openUpdateAmountModal(
                                                  gochi,
                                                  coupon
                                                );
                                              }}
                                            >
                                              金額修正
                                            </Button>
                                          </div>
                                        ) : null}
                                      </div>
                                    </Popover>
                                  </>
                                )}
                            </div>
                          );
                        })}
                    </>
                  ) : (
                    <>
                      {gochi.sourceTable === GOCHI_KID
                        ? gochi.amountTransferToShopWhenUseTotal &&
                          gochi.amountTransferToShopWhenUseTotal.toLocaleString()
                        : gochi.amountTransferToShopWhenUseShashoku &&
                          gochi.amountTransferToShopWhenUseShashoku.toLocaleString()}
                      {isFukuoka &&
                        gochi.sourceTable === 'SHASHOKU' &&
                        ((gochi.editAmountFlag === 1 &&
                          gochi.amountTransferToShopWhenUseShashoku) ||
                          gochi.showHistoryFlag === 1) && (
                          <>
                            <Button
                              key={`SHASHOKU-${gochi.shashokuTicketId}`}
                              ref={popoverAnchor}
                              onClick={e =>
                                handlePopoverOpen(
                                  e,
                                  `SHASHOKU-${gochi.shashokuTicketId}`
                                )
                              }
                              className={classes.btnMoreUpdateAmount}
                            >
                              <MoreHorizIcon />
                            </Button>
                            <Popover
                              elevation={1}
                              id="mouse-over-popover"
                              open={
                                openedPopoverId ===
                                `SHASHOKU-${gochi.shashokuTicketId}`
                              }
                              anchorEl={anchorEl}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                              }}
                              onClose={handlePopoverClose}
                              disableRestoreFocus
                            >
                              <div className={classes.btnUpdateAmountBox}>
                                {gochi.showHistoryFlag ? (
                                  <div>
                                    <Button
                                      className={classes.btnUpdateAmountHistory}
                                      onClick={() =>
                                        openUpdateAmountHistory(
                                          null,
                                          gochi.shashokuTicketId
                                        )
                                      }
                                    >
                                      金額修正履歴
                                    </Button>
                                  </div>
                                ) : null}
                                {gochi.editAmountFlag &&
                                gochi.amountTransferToShopWhenUseShashoku ? (
                                  <div>
                                    <Button
                                      className={classes.btnUpdateAmount}
                                      onClick={() => {
                                        openUpdateAmountModal(gochi, null);
                                      }}
                                    >
                                      金額修正
                                    </Button>
                                  </div>
                                ) : null}
                              </div>
                            </Popover>
                          </>
                        )}
                    </>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        {/* {emptyRows > 0 && (
          <TableRow>
            <TableCell colSpan={7} />
          </TableRow>
        )} */}
      </TableBody>
    );
  }
);

export default withStyles(styles)(GochiTableBody);
